import Vue from 'vue';
import Vuex from 'vuex';
import commondata from "./CommonData";
import createPersistedState from "vuex-persistedstate";
import getters from "./getters";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState()],
  modules: {
    commondata
  },
  getters,
})


// WEBPACK FOOTER //
// ./src/store/index.js